
import Axios from 'axios';
import { EVENT_LOGIN_REDIRECT } from '../constants/constants';
import storage from '../helpers/storage';

// custom Event to listen and move to login
const myEvent = new Event(EVENT_LOGIN_REDIRECT);

/**
 * Token Interceptor
 * @param {*} config
 * @returns {*}
 */
function authRequestInterceptor(config: any) {
    const token = storage.getToken();
    if (token) {
        config.headers.authorization = `Bearer ${token}`;
    }
    config.headers.Accept = 'application/json';
    return config;
}


const httpClient = Axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

// Add a request interceptor
httpClient.interceptors.request.use(authRequestInterceptor);

// Add a response interceptor
httpClient.interceptors.response.use(
    (response) => {
        // You can modify the response here (e.g., data transformation)
        return response.data;
    },
    (error) => {
        /**
         * Unauthorized - 401
         * Logout the user
         */
        if (error.response?.status === 401) {
            storage.clearToken();
            document.dispatchEvent(myEvent)
        }
        
        /**
         * Invalid body error code.
         */
        if((error?.response?.status === 409) && (error.response?.data as any)?.message) {
            try {
                const msgType = JSON.parse((error.response?.data as any)?.message || "") ?? "";
                if(typeof msgType === 'object') {
                    (error.response?.data as any).message = msgType;
                    (error.response?.data as any).invalid_body = true;
                }
            } catch (e) {}
        }
        // You can handle errors globally here
        return Promise.reject(error.response);
    }
);

export default httpClient;
